import { setPath } from "myredux/globalSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { StoreState } from "types";
import { isUndefined } from "utils/utils";

export const useDefault = () => {
    const { user } = useSelector((state: StoreState) => state.login);

    const { path, companies, selectedCompanyId, dates, period } = useSelector((state: StoreState) => state.global);
    
    const navigation = useNavigate();
    const dispatch = useDispatch();
    
    const [loading, setLoading] = useState<boolean>(false);
    const [showMenu, setShowMenu] = useState<boolean>(false);
    
    useEffect(() => {
        const layoutType = localStorage.getItem("layoutType");
        setShowMenu(layoutType === 'menu');
    }, []);

    useEffect(() => {
        if (!isUndefined(path)) {
            navigation(path!);
            dispatch(setPath(""));
        }
    }, [path]);
    
    const getLogo = () => {
        if (companies.length === 0) return undefined;
        try {
            const ico = companies.filter(c => +c.id === selectedCompanyId)[0].ic;
            return require(`../assets/logos/${ico}.jpg`);
        } catch (error) {
            return undefined;
        }
    };

    return {
        user,
        loading,
        setLoading,

        navigation,
        dispatch,

        showMenu,

        getLogo,

        companies,
        selectedCompanyId,
        dates,
        period
    };
};